<template>
        <span v-if="hasAnyNotes" class="note-hover"
            @mouseenter="openPopover"
            @mouseleave="closePopover">
        <i class="fas fa-sticky-note note-icon" aria-hidden="true"></i>

        <div class="note-popover" :class="{ above: isPopoverAbove }" v-show="isPopoverVisible">
            <div v-if="hasInternalNote" class="note-card internal">
            <div class="note-title">Internal note:</div>
            <div class="note-body" :title="internalNote">{{ limitedInternalnote }}</div>
        </div>

        <div v-if="hasNote" class="note-card external">
            <div class="note-title">Notes:</div>
            <div class="note-body" :title="note">{{ limitedNote }}</div>
        </div>
    </div>
    </span>
</template>

<script>
import hoverHelper from '@/utils/hoverHelper';

export default {
    name: 'NotesHover',
    props: {
        note: { type: String, default: null },
        internalNote: { type: String, default: null },
        reservation: { type: Object, default: null },
        NoteMaxLength: { type: Number, default: 350 }
    },
    data () {
        return {
            isPopoverVisible: false,
            isPopoverAbove: false
        };
    },
    computed: {
        limitedNote () {
            const note = this.reservation.note;
            const max = this.NoteMaxLength;
            return note.length > max ? note.slice(0, max) + '...' : note;
        },
        limitedInternalnote () {
            const note = this.reservation.internalNote;
            const max = this.NoteMaxLength;
            return note.length > max ? note.slice(0, max) + '...' : note;
        },
        hasNote () { 
            const note = this.reservation.note;
            return !!(note && note.trim());
        },
        hasInternalNote() { 
            const note = this.reservation.internalNote;
            return !!(note && note.trim());
        },
        hasAnyNotes () { 
            return this.hasNote || this.hasInternalNote;
        }
    },
    methods: {
        ...hoverHelper
    }
};
</script>

<style scoped>
    .note-hover {
        position: relative;
        display: inline-flex;
        align-items: center;
        margin-left: 8px;
    }

    .note-icon {
        cursor: pointer;
        font-size: 17px;
        color: #6b7280;
        transition: color .12s ease, transform .12s ease;
    }

    .notes-hover {
        margin-left: 6px;
        vertical-align: middle;
        display: inline-block;
    }

    .note-popover {
        position: absolute;
        top: 100%;
        right: 20px;
        left: auto;
        transform: none;
        display: flex;
        gap: 8px;
        border: none;
        background: transparent;
        border-radius: 4px;
        padding: 6px;
        box-shadow: none;
        box-sizing: border-box;
        max-width: 500px;
        overflow-x: auto;
    }

    .note-popover.above {
        top: auto;
        bottom: 100%;
        margin-top: 0;
    }

    .note-card {
        min-width: 80px;
        flex: 0 0 170px;
        max-width: 170px;
        box-sizing: border-box;
        align-self: flex-start;
        border: 1px solid #e6eaee;
        border-radius: 4px;
        padding: 6px;
        background: #fff;
        box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
        text-align: left;
    }

    .note-title {
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 8px;
        color: #111827;
    }

    .note-body {
        font-size: 11px;
        line-height: 1.5;
        color: #4B536B;
        font-weight: 100;
        white-space: pre-wrap;
        overflow-wrap: anywhere;
        word-break: break-word;
        min-width: 40px;
    }
</style>



// WEBPACK FOOTER //
// NotesHover.vue?7a461845